import loadableComponent from 'apps/marketplace/pages/shipment-details/utils/loadableComponent'

export default loadableComponent(() =>
  import(
    /* webpackPrefetch: true */
    './AssignDriverNowInputGroup'
  )
)
